import { render, staticRenderFns } from "./BInputCEP.vue?vue&type=template&id=098c0602&"
import script from "./BInputCEP.vue?vue&type=script&lang=js&"
export * from "./BInputCEP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports